import { useEffect, useId, type ReactNode } from 'react';
import { t } from '../i18n/uk.js';

/** A popup over the page: closes on Escape, the × button or a click on the backdrop. */
export function Modal({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  const titleId = useId();
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => event.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <div
      className="modal-backdrop"
      onMouseDown={(event) => event.target === event.currentTarget && onClose()}
    >
      <div role="dialog" aria-modal="true" aria-labelledby={titleId} className="modal">
        <header className="modal-header">
          <h2 id={titleId}>{title}</h2>
          <button type="button" className="icon" aria-label={t.catalogue.close} onClick={onClose}>
            ×
          </button>
        </header>
        {children}
      </div>
    </div>
  );
}
